import { VehicleType } from "@prisma/client-generated";
import { z } from "zod";

export const vehicleSchemaCreate = z.object({
  isJoint: z.boolean(),
  vehicleType: z.nativeEnum(VehicleType),
  make: z.string(),
  model: z.string(),
  purchaseYear: z.number().int().min(1900),
  purchasePriceInCents: z.number().min(0),
  fairMarketValueInCents: z.number().positive().nullish(),
  outstandingLoanInCents: z.number().positive().nullish(),
  equityInCents: z.number().positive().nullish(),
  currency: z.string().nullish(),
  userAPercentage: z.number().int().min(0).max(100).nullish(),
  userBPercentage: z.number().int().min(0).max(100).nullish(),
});

export const vehicleSchemaUpdate = vehicleSchemaCreate.partial();
